<template>
    <form @submit.prevent="handleSubmit">

        <div class="row mb-3 align-items-center">
            <div class="col-md-8">
                <label class="form-label">Actividad:</label>
                <input type="text" class="form-control" v-model="formData.activity"
                    required />
            </div>
            <div class="col-md-4">
                <label class="form-label">¿Es Facturable?</label>
                <div class="form-check form-switch mb-1 ms-4">
                    <input v-model="formData.is_billable" class="form-check-input form-check-input-warning"
                        type="checkbox" />
                </div>
            </div>
        </div>

        <div class="row mb-3 align-items-center">
            <div class="col-md-12">
                <label class="form-label">Descripción:</label>
                <input type="text" class="form-control" v-model="formData.description" />
            </div>
        </div>

        <div>
            <button type="submit" class="btn btn-warning w-100">Guardar</button>
        </div>
    </form>
</template>

<script setup>

import { ref } from "vue";
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const formData = ref({
    activity: '',
    description: '',
    is_billable: false,
})

const handleSubmit = async () => {

    try {
        const response = await axios.post(`${API_BASE_URL}/create-activity`, formData.value, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status == 200) {
            alert('Actividad Creada')
            window.location.reload();
        }
    } catch (error) {
        console.error('Error al obtener los datos del usuario:', error);
    }
}
</script>
